<template>
  <section id="Service">
    <div class="row">
      <div class="title col-md-8 d-none d-lg-flex align-items-center justify-content-start ml-auto">
        <h1 class="h5">認識 HS超集點</h1>
      </div>
      <div class="col-12 mt-25">
        <div class="card w-100 border-0 rounded-0">
          <div class="card-body p-0">
            <div class="row">
              <div class="img col-lg-4">
                <div class="w-100 pt-50 d-flex align-items-start justify-content-center">
                  <h1 class="h4 text-white d-lg-none">認識 HS超集點</h1>
                  <img
                    src="@/assets/image/card.png"
                    alt="H's vibe card"
                    class="d-flex align-items-center justify-content-center"
                  />
                </div>
              </div>
              <div class="col-lg-8">
                <div class="desc w-100 h-100">
                  <p>HS超集點是台灣唯一結合全方位生活美學領先體驗的紅利積點與會員服務，由漢齊科技整合國揚集團旗下之漢來大飯店、漢神百貨、漢來美食等核心產業。未來，將陸續提供更多跨產業、涵蓋生活相關 的多樣特約商服務，提供消費累點與兌點等多樣性會員忠誠回饋機制，讓消費者有更自主、彈性、實用的 點數運用與優惠選擇。</p>
                  <p>快加入HS超集點享受最優惠的消費折抵、海港、漢來美食等餐券兌換及多種不定期的卡友禮、 免費贈品等超值活動。</p>
                  <p>
                   下載HS超集點積點APP，免費申請即可成為會員，獨享眾多禮遇！
                  </p>
                  <ol>
                    <li>新會員立即贈30點 下載APP註冊會員成功後，會員帳戶已立即存有贈禮30點<br/>(每人限領一次)。</li>
                    <li>首次於漢來大飯店消費，加碼贈30點 首次到漢來大飯店消費(滿NT$3,000)可獲得加碼點數30點。將於消費日次月的15號以前匯入會員帳戶(每人限領一次)。</li>
                  </ol>
                  <div class="notice mt-30">
                    <div>
                      <p>專屬會員權益：</p>
                      <ol class="notice-ol">
                        <li>於各特約商單筆消費滿10元集0.03點，滿20元集0.06點，以此類推</li>
                        <li>於手機內兌換優惠券，即換即用，優惠券種類多元價值無上限</li>
                        <li>獨家好禮與各特約商不定期專屬優惠</li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'Service',
  metaInfo: {
    title: '認識齊來卡 | ',
  },
};
</script>
<style lang="scss" scoped>
#Service {
  overflow: hidden;
  padding: 20px 0 100px;
  .title {
    border-bottom: 2px solid $primary-light;
  }
  .card {
    .card-body {
      border-radius: 10px;
      background: linear-gradient(to bottom, #9f9f9f 0%, #f6f6f6 45%);
      @media (min-width: 992px) {
        background: linear-gradient(to right, #9f9f9f 0%, #f6f6f6 45%);
      }
      .img {
        position: relative;
        @media (min-width: 992px) {
          padding-right: 50px;
        }
        & > div {
          background: #000;
          height: 250px;
          @media (min-width: 992px) {
            height: 100%;
          }
        }
        img {
          position: absolute;
          bottom: -80px;
          width: 330px;
          max-width: 70vw;
          height: auto;
          @media (min-width: 992px) {
            top: 20%;
            right: -10px;
            width: 80%;
            max-width: 330px;
          }
        }
      }
      .desc {
        padding: 120px 30px 40px;
        @media (min-width: 992px) {
          padding: 40px 30px 40px 20px;
        }
        p {
          margin-bottom: 15px;
        }
        ol:not(.notice-ol) {
          list-style: none;
          counter-reset: li;
          padding: 0;
          li {
            counter-increment: li;
            margin: 10px 0;
            position: relative;
            padding-left: 30px;
            &::before {
              position: absolute;
              content: counter(li);
              color: $sub-primary;
              display: inline-block;
              width: 25px;
              height: 25px;
              left: 0;
              top: 3px;
              text-align: center;
              background: $primary;
              line-height: 25px;
              border-radius: 50%;
            }
          }
        }
      }
      .notice {
        p,
        li {
          font-size: $font-size-sm * 0.875;
          @media (min-width: 576px) {
            font-size: $font-size-sm;
          }
        }
      }
    }
  }
}
</style>
